<template>
  <div class="sidebar__section sidebar__section--bottom">
    <div class="sidebar__foot">
      <div class="sidebar__logo">
        <Logo
          v-if="collapsed"
          variant="icon"
          class="sidebar__logo-mark"
          :alt="$tBrand('logo.alt')"
        />
        <ExternalLinkBaserowLogo v-else />
      </div>
      <div class="sidebar__foot-links">
        <!-- Icon-only, so the label has to come from the element itself: the
             glyph is a font icon with no text node, and this control is
             rail-visible where nothing else names it. -->
        <button
          v-tooltip="$t('sidebar.undo')"
          type="button"
          class="sidebar__foot-link"
          :class="{
            'sidebar__foot-link--loading': undoLoading,
          }"
          :aria-label="$t('sidebar.undo')"
          @click="undo(false)"
        >
          <i class="sidebar__foot-link-icon iconoir-undo"></i>
        </button>
        <button
          v-tooltip="$t('sidebar.redo')"
          type="button"
          class="sidebar__foot-link"
          :class="{
            'sidebar__foot-link--loading': redoLoading,
          }"
          :aria-label="$t('sidebar.redo')"
          @click="redo(false)"
        >
          <i class="sidebar__foot-link-icon iconoir-redo"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import undoRedo from '@baserow/modules/core/mixins/undoRedo'
import ExternalLinkBaserowLogo from '@baserow/modules/core/components/ExternalLinkBaserowLogo'

export default {
  name: 'SidebarFoot',
  components: { ExternalLinkBaserowLogo },
  mixins: [undoRedo],
  props: {
    collapsed: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    width: {
      type: Number,
      required: true,
    },
  },
}
</script>
